import { useEffect, useState } from "react";
import "./Setup.scss";

const appStorePage = "https://apps.apple.com/in/app/neosapien/id6740624306";
const playStorePage =
  "https://play.google.com/store/apps/details?id=xyz.neosapien.neo&hl=en_IN";

export default function Setup() {
  const [device, setDevice] = useState(null); // android, ios, other

  useEffect(() => {
    const userAgent = navigator.userAgent.toLowerCase();

    if (userAgent.includes("android")) setDevice("android");
    else if (/iphone|ipad/gi.test(userAgent)) setDevice("ios");
    else setDevice("other");
  }, []);

  useEffect(() => {
    if (device === "android") window.location.href = playStorePage;
    else if (device === "ios") window.location.href = appStorePage;
    // else window.location.href = "/";
  }, [device]);

  return (
    <div className="setup-container">
      <div className="setup-content">
        <p>
          <h1>Redirecting...</h1>
          <p>Please wait while we redirect you to the appropriate app store.</p>
        </p>

        <p>
          Or you can go to <a href={appStorePage}>App Store</a> or{" "}
          <a href={playStorePage}>Play Store</a> directly.
        </p>
      </div>
    </div>
  );
}
